// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.courses-container {
  display: flex;
  flex-direction: column;
}

.courses-jumbotron {
  display: flex;
  flex-direction: column;
  height: 30rem;
  width: 100%;
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/esther-book-pics.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.courses-description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 15rem;
  font-size: 1.5em;
  line-height: 2.1em;
  color: #551fbd;
  font-family: "Spartan", sans-serif;
}

.courses-bar {
  height: 0.5rem;
  margin: auto;
  width: 15em;
  background-image: linear-gradient(to right, #051937, #004c78, #00838f, #00b96c, #a5e300);
  border-radius: 4px;
}

.course-bar-section {
  margin: 1.5em auto;
}

.course-see-below {
  font-size: 1rem;
  text-align: center;
  color: darkgray;
}

.courses-title {
  margin: 3em auto;
  height: 0.5rem;
  width: 15em;
  color: #337def;
  border-radius: 4px;
}

.courses-grid-container {
  display: flex;
  flex-direction: column;
}

#categories {
  overflow: hidden;
  width: 90%;
  margin: 0 auto;
}

.clr:after {
  content: "";
  display: block;
  clear: both;
}

#categories li {
  position: relative;
  list-style-type: none;
  width: 27.8571428571%; /* = (100-2.5) / 3.5 */
  padding-bottom: 32.1676014517%; /* =  width /0.866 */
  float: left;
  overflow: hidden;
  visibility: hidden;
  transform: rotate(-60deg) skewY(30deg);
}

#categories li:nth-child(3n+2) {
  margin: 0 1%;
}

#categories li:nth-child(6n+4) {
  margin-left: 0.5%;
}

#categories li:nth-child(6n+4),
#categories li:nth-child(6n+5),
#categories li:nth-child(6n+6) {
  margin-top: -6.9285714285%;
  margin-bottom: -6.9285714285%;
  transform: translateX(50%) rotate(-60deg) skewY(30deg);
}

#categories li:nth-child(6n+4):last-child,
#categories li:nth-child(6n+5):last-child,
#categories li:nth-child(6n+6):last-child {
  margin-bottom: 0%;
}

#categories li * {
  position: absolute;
  visibility: visible;
}

#categories li > div {
  width: 100%;
  height: 100%;
  text-align: center;
  color: #fff;
  overflow: hidden;
  transform: skewY(-30deg) rotate(60deg);
  -webkit-backface-visibility: hidden;
}

/* HEX CONTENT */
#categories li img {
  left: -100%;
  right: -100%;
  width: auto;
  height: 100%;
  margin: 0 auto;
}

#categories div h1,
#categories div p {
  width: 90%;
  padding: 0 5%;
  background-color: #a5e300;
  background-color: rgba(57, 8, 121, 0.8);
  font-family: "Spartan", sans-serif;
  cursor: pointer;
  transition: top 0.2s ease-out, bottom 0.2s ease-out, 0.2s padding 0.2s ease-out;
}

#categories li h1 {
  bottom: 110%;
  font-style: italic;
  font-weight: normal;
  font-size: 1.5em;
  padding-top: 100%;
  padding-bottom: 100%;
}

#categories li h1:after {
  content: "";
  display: block;
  position: absolute;
  bottom: -1px;
  left: 45%;
  width: 10%;
  text-align: center;
  z-index: 1;
  border-bottom: 2px solid #fff;
}

#categories li p {
  padding-top: 50%;
  top: 110%;
  padding-bottom: 50%;
}

/* HOVER EFFECT  */
#categories li div:hover h1 {
  bottom: 50%;
  padding-bottom: 10%;
}

#categories li div:hover p {
  top: 50%;
  padding-top: 10%;
}

#fork {
  position: fixed;
  top: 0;
  left: 0;
  color: #000;
  text-decoration: none;
  border: 1px solid #000;
  padding: 0.5em 0.7em;
  margin: 1%;
  transition: color 0.5s;
  overflow: hidden;
}

#fork:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 130%;
  height: 100%;
  background: #000;
  z-index: -1;
  transform-origin: 0 0;
  transform: translateX(-100%) skewX(-45deg);
  transition: transform 0.5s;
}

#fork:hover {
  color: #fff;
}

#fork:hover:before {
  transform: translateX(0) skewX(-45deg);
}

@media (max-width: 500px) {
  .courses-description {
    padding: 1rem;
    font-size: 1rem;
  }
  #categories li h1 {
    font-size: 1rem;
  }
  #categories li p {
    display: none;
  }
}
video {
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/Training/Styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,yFAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AACJ;;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;AACJ;;AAEE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,wFAAA;EAQA,kBAAA;AANJ;;AASE;EACE,kBAAA;AANJ;;AASE;EACE,eAAA;EACA,kBAAA;EACA,eAAA;AANJ;;AASE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AANJ;;AASE;EACE,aAAA;EACA,sBAAA;AANJ;;AASE;EACE,gBAAA;EACA,UAAA;EACA,cAAA;AANJ;;AAQE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AALJ;;AAOE;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA,EAAA,sBAAA;EACA,8BAAA,EAAA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EAIA,sCAAA;AALJ;;AAOE;EACE,YAAA;AAJJ;;AAME;EACE,iBAAA;AAHJ;;AAKE;;;EAGE,0BAAA;EACA,6BAAA;EAIA,sDAAA;AAHJ;;AAKE;;;EAGE,iBAAA;AAFJ;;AAIE;EACE,kBAAA;EACA,mBAAA;AADJ;;AAGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EAIA,sCAAA;EAEA,mCAAA;AAFJ;;AAKE,gBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAFJ;;AAKE;;EAEE,UAAA;EACA,aAAA;EACA,yBAAA;EACA,uCAAA;EACA,kCAAA;EACA,eAAA;EAKA,+EAAA;AAJJ;;AAOE;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAJJ;;AAOE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;AAJJ;;AAME;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;AAHJ;;AAME,kBAAA;AAEA;EACE,WAAA;EACA,mBAAA;AAJJ;;AAOE;EACE,QAAA;EACA,gBAAA;AAJJ;;AAME;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;AAHJ;;AAKE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,0CAAA;EACA,0BAAA;AAFJ;;AAIE;EACE,WAAA;AADJ;;AAGE;EACE,sCAAA;AAAJ;;AAGE;EACE;IACE,aAAA;IACA,eAAA;EAAJ;EAGE;IACE,eAAA;EADJ;EAIE;IACE,aAAA;EAFJ;AACF;AAKE;EACE,UAAA;AAHJ","sourcesContent":[".courses-container {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .courses-jumbotron {\n    display: flex;\n    flex-direction: column;\n    height: 30rem;\n    width: 100%;\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/esther-book-pics.jpg\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n  }\n  \n  .courses-description {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 3rem 15rem;\n    font-size: 1.5em;\n    line-height: 2.1em;\n    color: #551fbd;\n    font-family: \"Spartan\", sans-serif;\n  }\n  \n  .courses-bar {\n    height: 0.5rem;\n    margin: auto;\n    width: 15em;\n    background-image: linear-gradient(\n      to right,\n      #051937,\n      #004c78,\n      #00838f,\n      #00b96c,\n      #a5e300\n    );\n    border-radius: 4px;\n  }\n  \n  .course-bar-section {\n    margin: 1.5em auto;\n  }\n  \n  .course-see-below {\n    font-size: 1rem;\n    text-align: center;\n    color: darkgray;\n  }\n  \n  .courses-title {\n    margin: 3em auto;\n    height: 0.5rem;\n    width: 15em;\n    color: #337def;\n    border-radius: 4px;\n  }\n  \n  .courses-grid-container {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  #categories {\n    overflow: hidden;\n    width: 90%;\n    margin: 0 auto;\n  }\n  .clr:after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n  #categories li {\n    position: relative;\n    list-style-type: none;\n    width: 27.85714285714286%; /* = (100-2.5) / 3.5 */\n    padding-bottom: 32.16760145166612%; /* =  width /0.866 */\n    float: left;\n    overflow: hidden;\n    visibility: hidden;\n  \n    -webkit-transform: rotate(-60deg) skewY(30deg);\n    -ms-transform: rotate(-60deg) skewY(30deg);\n    transform: rotate(-60deg) skewY(30deg);\n  }\n  #categories li:nth-child(3n + 2) {\n    margin: 0 1%;\n  }\n  #categories li:nth-child(6n + 4) {\n    margin-left: 0.5%;\n  }\n  #categories li:nth-child(6n + 4),\n  #categories li:nth-child(6n + 5),\n  #categories li:nth-child(6n + 6) {\n    margin-top: -6.9285714285%;\n    margin-bottom: -6.9285714285%;\n  \n    -webkit-transform: translateX(50%) rotate(-60deg) skewY(30deg);\n    -ms-transform: translateX(50%) rotate(-60deg) skewY(30deg);\n    transform: translateX(50%) rotate(-60deg) skewY(30deg);\n  }\n  #categories li:nth-child(6n + 4):last-child,\n  #categories li:nth-child(6n + 5):last-child,\n  #categories li:nth-child(6n + 6):last-child {\n    margin-bottom: 0%;\n  }\n  #categories li * {\n    position: absolute;\n    visibility: visible;\n  }\n  #categories li > div {\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    color: #fff;\n    overflow: hidden;\n  \n    -webkit-transform: skewY(-30deg) rotate(60deg);\n    -ms-transform: skewY(-30deg) rotate(60deg);\n    transform: skewY(-30deg) rotate(60deg);\n  \n    -webkit-backface-visibility: hidden;\n  }\n  \n  /* HEX CONTENT */\n  #categories li img {\n    left: -100%;\n    right: -100%;\n    width: auto;\n    height: 100%;\n    margin: 0 auto;\n  }\n  \n  #categories div h1,\n  #categories div p {\n    width: 90%;\n    padding: 0 5%;\n    background-color: #a5e300;\n    background-color: rgba(57, 8, 121, 0.8);\n    font-family: \"Spartan\", sans-serif;\n    cursor: pointer;\n    -webkit-transition: top 0.2s ease-out, bottom 0.2s ease-out,\n      0.2s padding 0.2s ease-out;\n    -ms-transition: top 0.2s ease-out, bottom 0.2s ease-out,\n      0.2s padding 0.2s ease-out;\n    transition: top 0.2s ease-out, bottom 0.2s ease-out,\n      0.2s padding 0.2s ease-out;\n  }\n  #categories li h1 {\n    bottom: 110%;\n    font-style: italic;\n    font-weight: normal;\n    font-size: 1.5em;\n    padding-top: 100%;\n    padding-bottom: 100%;\n  }\n  \n  #categories li h1:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: -1px;\n    left: 45%;\n    width: 10%;\n    text-align: center;\n    z-index: 1;\n    border-bottom: 2px solid #fff;\n  }\n  #categories li p {\n    padding-top: 50%;\n    top: 110%;\n    padding-bottom: 50%;\n  }\n  \n  /* HOVER EFFECT  */\n  \n  #categories li div:hover h1 {\n    bottom: 50%;\n    padding-bottom: 10%;\n  }\n  \n  #categories li div:hover p {\n    top: 50%;\n    padding-top: 10%;\n  }\n  #fork {\n    position: fixed;\n    top: 0;\n    left: 0;\n    color: #000;\n    text-decoration: none;\n    border: 1px solid #000;\n    padding: 0.5em 0.7em;\n    margin: 1%;\n    transition: color 0.5s;\n    overflow: hidden;\n  }\n  #fork:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 130%;\n    height: 100%;\n    background: #000;\n    z-index: -1;\n    transform-origin: 0 0;\n    transform: translateX(-100%) skewX(-45deg);\n    transition: transform 0.5s;\n  }\n  #fork:hover {\n    color: #fff;\n  }\n  #fork:hover:before {\n    transform: translateX(0) skewX(-45deg);\n  }\n  \n  @media (max-width: 500px) {\n    .courses-description {\n      padding: 1rem;\n      font-size: 1rem;\n    }\n  \n    #categories li h1 {\n      font-size: 1rem;\n    }\n  \n    #categories li p {\n      display: none;\n    }\n  }\n  \n  video {\n    z-index: 1;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
